import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Supplier} from './supplier';

@Injectable()
export class SupplierService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('suppliers?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('suppliers/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('suppliers/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('suppliers/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(supplier: Supplier) {
    return this.http.post('suppliers', supplier).map((response: Response) => response.json());
  }

  update(supplier: Supplier) {
    return this.http.put('suppliers/' + supplier.id, supplier).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('suppliers/' + _id).map((response: Response) => response.json());;
  }

    getAllSuppliers() {
        return this.http.get('suppliers/all').map((response: Response) => response.json());
    }


  static emailValidator(control) {
    // RFC 2822 compliant regex
    if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
      return null;
    } else {
      return { 'invalidEmailAddress': true };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/suppliers/supplier.service.ts